<template>
  <generic-list
    :model="model"
    :model-headers="modelHeaders"
    disable-delete
  ></generic-list>
</template>

<script>
import model from "./model"

export default {
  name: "List",
  data() {
    return {
      model,
      modelHeaders: [
        { text: "Nome", value: "name" },
        { text: "Data inizio", value: "start_date" },
        { text: "Data fine", value: "end_date" },
      ],
    }
  },
}
</script>
